import React from 'react';
import { Helmet } from 'react-helmet';
import newimage from "../assets/newimage.png";
import Headingcomp from '../components/Headingcomp';
import "../components/css/Service.css";
import Servicemap from '../components/Servicemap';

const Service = () => {
    return (
        <main>
           <Helmet>
    <title>Dhiman Wood Works | Premium Custom Wooden Furniture</title>
    <meta name="description" content="Transform your space with handcrafted wooden furniture by master craftsman Babu Ram Dhiman. Explore our custom furniture, cabinetry and interior woodwork." />
</Helmet>

            <Headingcomp
                heading="WOODWORKING SERVICES"
                subheading="CRAFTING EXCELLENCE IN WOOD"
                image={newimage}
            />

            <div className='service-container-heading'>
                <h1 className='service-container-heading-content1'>EXPERT CRAFTSMANSHIP</h1>
            </div>

            <Servicemap />
        </main>
    );
}

export default Service;
